(() => {
  class MHeader extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };

    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.stickyEnabled = "true" === this.dataset.sticky;
    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
    };
    this._initialized = false;
    this._eventsBound = false;
    this._lastScrollY = window.scrollY;

    this._onScroll = this.handleScroll.bind(this);
    this._onResize = this.handleResize.bind(this);
    this._onBreakpointChange = this.handleBreakpointChange.bind(this);
  }

  connectedCallback() {
    if (!this._initialized) {
      this._initialized = true;
      this.init();
    }

    this.bindEvents();
  }

  disconnectedCallback() {
    this.unbindEvents();
  }

  init() {
    this.transparentHeader =
      this.domNodes?.headers?.[0]?.dataset.transparent === "true";
    this.refreshMetrics();
    this.initAddon();

    if ("function" === typeof SiteNav) {
      this.siteNav = new SiteNav(this);
    }

    window.__sfHeader = this;
  }

  initAddon() {
    this.megamenu = new Megamenu(this);

    if (
      typeof Shopify !== "undefined" &&
      Shopify.designMode &&
      typeof MinimogTheme !== "undefined" &&
      MinimogTheme.Wishlist &&
      typeof MinimogTheme.Wishlist.updateWishlistCount === "function"
    ) {
      MinimogTheme.Wishlist.updateWishlistCount();
    }
  }

  bindEvents() {
    if (this._eventsBound) return;

    window.addEventListener("scroll", this._onScroll, { passive: true });
    window.addEventListener("resize", this._onResize, { passive: true });
    document.addEventListener("matchMobile", this._onBreakpointChange);
    document.addEventListener("unmatchMobile", this._onBreakpointChange);
    this._eventsBound = true;

    this.refreshMetrics();
    this._lastScrollY = window.scrollY;
    this.handleScroll();
  }

  unbindEvents() {
    if (!this._eventsBound) return;

    window.removeEventListener("scroll", this._onScroll);
    window.removeEventListener("resize", this._onResize);
    document.removeEventListener("matchMobile", this._onBreakpointChange);
    document.removeEventListener("unmatchMobile", this._onBreakpointChange);
    this._eventsBound = false;
  }

  refreshMetrics() {
    const wrapper = this.domNodes?.headerWrapper;
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = wrapper?.offsetTop || 0;
    this.headerHeight = wrapper?.offsetHeight || 0;
  }

  getStickyThreshold() {
    let threshold = 20;

    document
      .querySelectorAll(".shopify-section-group-header-group")
      .forEach((section) => {
        if (!section.classList.contains("m-section-header")) {
          threshold += section.offsetHeight;
        }
      });

    const topbar = document.querySelector(".m-topbar");
    if (topbar) threshold += topbar.offsetHeight;

    return threshold;
  }

  handleResize() {
    this.refreshMetrics();
    this._lastScrollY = window.scrollY;
    this.handleScroll();
  }

  handleBreakpointChange() {
    this.refreshMetrics();
    this._lastScrollY = window.scrollY;
    this.classList.remove(this.classes.scrollUp, this.classes.scrollDown);
    this.handleScroll();
  }

  handleScroll() {
    if (!this.stickyEnabled) return;

    const currentScrollY = window.scrollY;
    const threshold = this.getStickyThreshold();
    const scrollingDown = currentScrollY > this._lastScrollY;
    const scrollingUp = currentScrollY < this._lastScrollY;

    if (currentScrollY <= threshold) {
      this.classList.remove(
        this.classes.scrollUp,
        this.classes.scrollDown,
        this.classes.stuck
      );
    } else {
      this.classList.add(this.classes.stuck);

      if (
        currentScrollY > this.headerHeight + threshold &&
        scrollingDown
      ) {
        this.classList.remove(this.classes.scrollUp);
        this.classList.add(this.classes.scrollDown);
      } else if (scrollingUp) {
        this.classList.remove(this.classes.scrollDown);
        this.classList.add(this.classes.scrollUp);
      }
    }

    this._lastScrollY = currentScrollY;
  }
}

  if (!customElements.get("m-header")) {
    customElements.define("m-header", MHeader);
  }
})();
